declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    __RUNTIME_CONFIG__?: Record<string, any>;
  }
}

export function getRuntimeConfig() {
  return typeof window !== "undefined" ? (window.__RUNTIME_CONFIG__ ?? {}) : {};
}

/**
 * Gets environment variable from the appropriate source
 * - In production (browser): reads from window.__RUNTIME_CONFIG__
 * - In development: reads from import.meta.env (Vite dev server)
 *
 * @param key - The environment variable key
 * @returns The environment variable value or empty string if not found
 */
export function getEnv(key: string, fallback = ""): string {
  // In production, use runtime config
  if (typeof window !== "undefined" && window.__RUNTIME_CONFIG__) {
    const config = getRuntimeConfig();
    return config[key] || fallback;
  }

  // In development, use Vite's import.meta.env
  return import.meta.env[key] || fallback;
}
